import api from './api';

export const projectService = {
  // Get all projects for the current user
  getUserProjects: async () => {
    try {
      const response = await api.get('/projects/');
      return response.data;
    } catch (error) {
      console.error('Error fetching user projects:', error);
      throw error;
    }
  },

  // Create a new project
  createProject: async (projectData) => {
    try {
      const response = await api.post('/projects/', projectData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  },

  // Get a specific project by ID
  getProject: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  },

  // Update a project
  updateProject: async (projectId, projectData) => {
    try {
      const response = await api.put(`/projects/${projectId}/`, projectData);
      return response.data;
    } catch (error) {
      console.error('Error updating project:', error);
      throw error;
    }
  },

  // Delete a project
  deleteProject: async (projectId) => {
    try {
      const response = await api.delete(`/projects/${projectId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting project:', error);
      throw error;
    }
  },

  // Admin functions
  getAllProjects: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== 'all') {
          params.append(key, filters[key]);
        }
      });
      
      const response = await api.get(`/projects/admin/all/?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all projects:', error);
      throw error;
    }
  },

  assignConsultant: async (projectId, consultantId) => {
    try {
      const response = await api.post(`/projects/admin/${projectId}/assign-consultant/`, {
        consultant_id: consultantId
      });
      return response.data;
    } catch (error) {
      console.error('Error assigning consultant:', error);
      throw error;
    }
  },

  updateProjectStatus: async (projectId, status) => {
    try {
      const response = await api.post(`/projects/admin/${projectId}/update-status/`, {
        status: status
      });
      return response.data;
    } catch (error) {
      console.error('Error updating project status:', error);
      throw error;
    }
  }
};